import { StaffChatWidget } from "@/components/chat-widget/staff-chat-widget";
import { isChatWidgetEnabled } from "@/components/chat-widget/chat-preferences";
import { ClinicianCopilotWidget } from "@/components/shared/clinician-copilot-widget";
import { FloatingActionDock } from "@/components/shared/floating-action-dock";
import { useAuth } from "@/hooks/use-auth";
import { useHasUserProduct } from "@/hooks/use-user-products";
import { useWorkbench } from "./workbench-provider";

export function WorkbenchFloatingDock() {
  const { user } = useAuth();
  const { copilotEnabled, setCopilotEnabled } = useWorkbench();
  const canUseAi = useHasUserProduct("ai_notes");

  return (
    <FloatingActionDock>
      {copilotEnabled && canUseAi && (
        <ClinicianCopilotWidget enabled={copilotEnabled} onToggleEnabled={setCopilotEnabled} />
      )}
      {isChatWidgetEnabled(user) && <StaffChatWidget />}
    </FloatingActionDock>
  );
}
